import { createSlice } from "@reduxjs/toolkit";
import Cookies from "js-cookie";
const cookie = Cookies.get("user") || null;
let userData = "";
if (cookie) {
  userData = JSON.parse(cookie);
}
export const nhmApplicantsFilterSlice = createSlice({
  name: "nhmApplicants",
  initialState: {
    currentPage: 1,
    filters: {
      startdate: "",
      enddate: "",
      Mobile: "",
      Name: "",
      District: "",
      Taluka: "",
      Village: "",
      Structure: "",
      System: "",
      seenStatus: "",
    },
  },
  reducers: {
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload;
    },
    setReduxFilters: (state, action) => {
      state.filters = action.payload;
    },
  },
});

export const { setCurrentPage, setReduxFilters } =
  nhmApplicantsFilterSlice.actions;
export default nhmApplicantsFilterSlice.reducer;
